import React, { useEffect, useRef, useState } from 'react';
import Drawer from 'react-modern-drawer';
import songServices from './songServices';
import DeleteDialogueBox from 'components/Common/deleteDialogue';
import { SearchContract } from 'components/Contracts/SearchContract';
import { ContactFormSearch } from 'components/Contacts/contactFormSearch';
import Modal from 'react-responsive-modal';

export function SongSplitsCollector(songSplitsCollector: any) {
    console.log(songSplitsCollector)

    let [editParam, setEditParam] = useState<any>([]);
    let [totalSplitCss, settotalSplitCss] = useState(0);
    let [deleteStatus, setDeleteStatus] = useState(false);
    let [composerOpen, setcomposerOpen] = useState(false);
    let [deleteCollector, setDeleteCollector] = useState<any>([]);
    let [songSplitsCollCount, setsongSplitsCollCount] = useState(0);
    let [openSearchContract, setopenSearchContract] = useState(false);
    let [songSplitsCollList, setsongSplitsCollList] = useState<any>([]);
    let [selectedSongSplitSearch, setselectedSongSplitSearch] = useState<any>([]);
    let [selectedSongCollectorSearch, setselectedSongCollectorSearch] = useState<any>([]);

    var payload = { SongPubTID: songSplitsCollector?.data?.songPubTID, pageNumber: 1, pageSize: 10 }

    const closeSongSplitsCollector = () => { songSplitsCollector.closeSongSplitsCollectors(); }

    useEffect(() => {

        totalSplitCss = 0
        settotalSplitCss(totalSplitCss)

        if (songSplitsCollector.data) {
            selectedSongSplitSearch = songSplitsCollector.data
            setselectedSongSplitSearch(selectedSongSplitSearch)
        }

        if (songSplitsCollector.song) {
            selectedSongCollectorSearch = songSplitsCollector.song
            setselectedSongCollectorSearch(selectedSongCollectorSearch)
        }

        apiCall();
    }, []);

    const apiCall = () => {
        songServices.songSplitsCollList(payload).then((respond: any) => {
            songSplitsCollList = respond
            setsongSplitsCollList(songSplitsCollList)
            songSplitsCollCount = respond?.length
            setsongSplitsCollCount(songSplitsCollCount)
            for (var i = 0; respond[i]; i++) {
                totalSplitCss = totalSplitCss + respond[i]?.mechCollSplit
                settotalSplitCss(totalSplitCss)
            }
        })
    }

    const editSongsCollSplit = (splitCollector: any) => {
        console.log(splitCollector)
        editParam = splitCollector
        setEditParam({ ...editParam })
    }

    const splitCollectorSave_Same = () => {

        if (validateData()) {

            songServices.songSplitsCollSave(editParam).then(() => {
                apiCall();
                editParam = []
                setEditParam({ ...editParam });
            })
        }
    }

    const validateData = () => {

        let valid_status = true;
        var fieldName_contractRefNum: any = document.getElementById("contractRefNum");
        var fieldName_collectorName: any = document.getElementById("collectorName");

        if (editParam?.contractRefNum?.length == 0) {
            valid_status = false;
            fieldName_contractRefNum.style.border = "1px solid #ff0000";
        }

        if (editParam?.collectorCode?.length == 0) {
            valid_status = false;
            fieldName_collectorName.style.border = "1px solid #ff0000";
        }

        setTimeout(function () {
            fieldName_contractRefNum.style.border = "1px solid #dedede";
            fieldName_collectorName.style.border = "1px solid #dedede";
        }, 3000);

        return valid_status
    }

    const deleteSongsCollSplit = (splitCollector: any) => {
        deleteCollector = splitCollector
        setDeleteCollector(deleteCollector)
        deleteStatus = true;
        setDeleteStatus(deleteStatus)
    }

    const Confirmation = (e: any) => {
        if (e === 1) {
            if (deleteCollector?.songCollID) {
                songServices.songSplitsCollectorDelete(deleteCollector?.songCollID)
            }
        }
        deleteStatus = false;
        setDeleteStatus(deleteStatus);
    }

    const closeSearchContract = (e: any) => {
        console.log(e)
        openSearchContract = false
        setopenSearchContract(openSearchContract)

        if (e?.contractSelected) {
            editParam.contractTitle = e?.contractSelected?.contractTitle
            editParam.contractRefNum = e?.contractSelected?.contractRefNum
            editParam.collectorName = e?.contractSelected?.kontactName
            editParam.collectorCode = e?.contractSelected?.kontactCode
            setEditParam({ ...editParam })
        }
    }

    const onChangeComposer = (e: any) => {
        console.log(e)
        if (e) {
            editParam.collectorCode = e?.kontactCode
            editParam.collectorName = e?.kontactName
            setEditParam({ ...editParam })
        }

    }

    return (<>

        <Modal open={songSplitsCollector.openSongSplitsCollector} onClose={closeSongSplitsCollector} styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }} >

            <div className="ws-12 box landing  full-height  allowHscroll allowVscroll" >

                <div className="box-header-main"> <h2> Collector for Publishing Split</h2> </div>

                <div className="box-content form-box" style={{ zIndex: 1100 }}>

                    {/* header PANEL */}
                    <div className="row-fluid">

                        <div className="allowHscroll allowVscroll">
                            <table className="newTable">
                                <thead>
                                    <tr>
                                        <th>Song Ref</th>
                                        <th>Song Title</th>
                                        <th>Main Composers</th>
                                        <th>Main Publishers</th>
                                        <th>ISWC</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td> {selectedSongCollectorSearch?.songRef} </td>
                                        <td> {selectedSongCollectorSearch?.songName} </td>
                                        <td> {selectedSongCollectorSearch?.songMainComposer} </td>
                                        <td> {selectedSongCollectorSearch?.songMainPublisher} </td>
                                        <td> {selectedSongCollectorSearch?.intStdWorkCode} </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <div className='hide'>

                            <div className="form-format ws-6 ml">
                                <label className="control-label" > Song Ref</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Track" id="Text5" name="selectedIsrc" readOnly ng-model="selectedSong.songRef" />

                                </div>
                            </div>

                            <div className="form-format ws-6">
                                <label className="control-label" > Main Composers</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Song Main Composer" id="Text2" name="trackName" className="text-uppercase" ng-model="selectedSongSplit.songMainComposer" readOnly />
                                </div>
                            </div>

                            <div className="form-format ws-6">
                                <label className="control-label" > ISWC</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="ISWC" id="selectedIsrc" name="selectedIsrc" ng-model="selectedSong.intStdWorkCode" readOnly />
                                </div>
                            </div>

                            <div className="form-format ws-6">
                                <label className="control-label" > Main Publishers</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Enter Song Main Publisher" id="Text1" name="trackName" className="text-uppercase" ng-model="selectedSongSplit.songMainPublisher" readOnly />
                                </div>
                            </div>

                            <div className="form-format ws-6">
                                <label className="control-label" > Song Title</label>

                                <div className="label-entries">
                                    <input type="text" placeholder="Track" id="trackName" name="trackName" ng-model="selectedSong.songName" readOnly />
                                </div>
                            </div>

                        </div>

                        <div className="w-49 mt">
                            <div className="table-responsive">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th>Writer/Publisher</th>
                                            <th>Collector</th>
                                            <th>Collector Type</th>
                                            <th>% Split</th>
                                            <th>Contract</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{selectedSongSplitSearch?.writerCodeDisplay}/{selectedSongSplitSearch?.publishersDisplay}</td>
                                            <td>{selectedSongSplitSearch?.collectedByDisplay}</td>
                                            <td>{selectedSongSplitSearch?.collectedFlag}</td>
                                            <td>{selectedSongSplitSearch?.publishingSplit}</td>
                                            <td>{selectedSongSplitSearch?.writersContract}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="ws-6 pull-right mt">
                            <div className="table-responsive">
                                <table className="newTable">
                                    <thead>
                                        <tr>
                                            <th>Mech</th>
                                            <th>Perf</th>
                                            <th>Sync</th>
                                            <th>Print</th>
                                            <th>Other</th>
                                            <th>Merch</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{selectedSongSplitSearch?.mechSplit}</td>
                                            <td>{selectedSongSplitSearch?.perfSplit}</td>
                                            <td>{selectedSongSplitSearch?.synchSplit}</td>
                                            <td>{selectedSongSplitSearch?.printSplit}</td>
                                            <td>{selectedSongSplitSearch?.otherSplit}</td>
                                            <td>{selectedSongSplitSearch?.merchSplit}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>

                    {/* EDIT PANEL */}
                    <div className="ws-12 box pm mtl">

                        <div className="form-format ws-6">
                            <label className="ws-12 text-bold">Collector Contract*</label>
                            <div className="ws-12">
                                <input className="ws-10" disabled value={editParam?.contractRefNum} id="contractRefNum" />
                                <button type="button" className="icon-btn info width70 height35" onClick={() => setopenSearchContract(true)}><i className="icon-user-add"></i></button>
                            </div>
                        </div>

                        <div className="form-format ws-6">
                            <label className="ws-12 text-bold">Collector Name*</label>
                            <div className="ws-8">
                                <input type="text" className="ws-10" value={editParam?.collectorName} placeholder="Enter Collector Name" id="collectorName" required name="collectorName" readOnly />
                                <ContactFormSearch onChange={onChangeComposer} data={""} open={composerOpen} />
                            </div>
                        </div>

                        <div className="ws-12">

                            <div className="form-format ws-6">
                                <label >Collector Type</label>
                                <div className="label-entries ws-8">
                                    <select name="collectorType" ng-model="selectedCollSongSplit.collectorType" value={editParam?.collectorType}>
                                        <option value="" >Choose a type</option>
                                        <option value="0" label="AQ">AQ</option><option value="1" label="AM">AM</option>
                                        <option value="2" label="PA">PA</option><option value="3" label="E">E</option>
                                        <option value="4" label="ES">ES</option><option value="5" label="SE">SE</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-format ws-6">
                                <label className="ws-12 text-bold">% Share of Original</label>
                                <div className="label-entries ws-8">
                                    <input type="text" placeholder="Share of Original %" name="shareOfOriginal" value={editParam?.shareOfOriginal} ng-model="selectedCollSongSplit.shareOfOriginal" />
                                </div>
                            </div>

                        </div>

                        <div className="ws-12 allowHscroll allowVscroll">
                            <div className='ws-4 pm'>
                                <label className="ws-12 text-bold">Mech</label>
                                <input className="text-right ws-10" type="text" ng-model="selectedCollSongSplit.mechCollSplit" value={editParam?.mechCollSplit} />
                            </div>

                            <div className='ws-4 pm'>
                                <label className="ws-12 text-bold">Perf</label>
                                <input className="text-right ws-10" type="text" value={editParam?.perfCollSplit} />
                            </div>

                            <div className='ws-4 pm'>
                                <label className="ws-12 text-bold">Sync</label>
                                <input className="text-right ws-10" type="text" value={editParam?.synchCollSplit} />
                            </div>

                            <div className='ws-4 pm'>
                                <label className="ws-12 text-bold">Print</label>
                                <input className="text-right ws-10" type="text" value={editParam?.printCollSplit} />
                            </div>

                            <div className='ws-4 pm'>
                                <label className="ws-12 text-bold">Other</label>
                                <input className="text-right ws-10" type="text" value={editParam?.otherCollSplit} />
                            </div>

                            <div className='ws-4 pm'>
                                <label className="ws-12 text-bold">Merch</label>
                                <input className="text-right ws-10" type="text" value={editParam?.merchCollSplit} />
                            </div>
                        </div>

                        <div className="ws-12 ">
                            <button className="icon-btn edit pull-right" onClick={splitCollectorSave_Same}>
                                <i className="icon-save"></i> Save
                            </button>
                        </div>
                    </div>

                    <div className="ws-12 box mt">
                        <div className="ws-12">
                            <div className="box-header well">  <h2><i className="icon-info"></i> {songSplitsCollCount} record(s) found</h2> </div>

                            <div className="box-content">
                                {songSplitsCollCount == 0 && <div className="alert alert-info"> No splits to display for this collector </div>}

                                {songSplitsCollCount > 0 && <div className="allowHscroll allowVscroll">
                                    <table className="newTable" data-ng-show="songsSplitsCollectorData.length > 0">
                                        <thead>
                                            <tr>
                                                <th>Publisher</th>
                                                <th>Collector</th>
                                                <th>Collector Type</th>
                                                <th>Contract</th>
                                                <th>Controlled</th>
                                                <th>% Split</th>
                                                <th>Mech</th>
                                                <th>Perf</th>
                                                <th>Sync</th>
                                                <th>Print</th>
                                                <th>Other</th>
                                                <th>Merch</th>
                                                <th>Operation</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                songSplitsCollList?.map((values: any) => {
                                                    return (

                                                        <tr>
                                                            <td>{values?.publisherName}</td>
                                                            <td className="text-uppercase">{values?.collectorName}</td>
                                                            <td>{values?.collectorType}</td>
                                                            <td>{values?.contractRefNum}</td>
                                                            <td>{values?.controlledYN == 0 ? 'N' : 'Y'}</td>
                                                            <td className="text-right">{values?.publishingSplit}</td>
                                                            <td className="text-right">{values?.mechCollSplit}</td>
                                                            <td className="text-right">{values?.perfCollSplit}</td>
                                                            <td className="text-right">{values?.synchCollSplit}</td>
                                                            <td className="text-right">{values?.printCollSplit}</td>
                                                            <td className="text-right">{values?.otherCollSplit}</td>
                                                            <td className="text-right">{values?.merchCollSplit}</td>
                                                            <td>
                                                                <a onClick={() => editSongsCollSplit(values)} className="icon-btn edit"><i className="icon-edit"></i></a>
                                                                <a onClick={() => deleteSongsCollSplit(values)} className="icon-btn delete"><i className="icon-trashcan"></i></a>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            <tr className="text-right text-bold text-xxl text-uppercase">
                                                <td className="text-right" colSpan={5}>Total</td>
                                                <td className="text-right bg-primary">{totalSplitCss} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>}

                                {songSplitsCollCount > 10 && <div className="clearfix">

                                </div>}

                            </div>
                        </div>

                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete" onClick={closeSongSplitsCollector}><i className="icon-close"></i> Close</button>
                    </div>

                </div>

                {
                    (() => {

                        if (deleteStatus) {
                            return <DeleteDialogueBox param={deleteStatus} message={"delete society collector "} onChange={Confirmation} />
                        }

                        if (openSearchContract) {
                            return <SearchContract openSearchContract={openSearchContract} data={editParam} closeSearchContract={closeSearchContract} />
                        }
                    })()
                }

            </div>
        </Modal>

    </>)
}    